import { Component, EventEmitter, Input, Output, signal } from '@angular/core'
import { CommonModule } from '@angular/common'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'
import { maxFileSize } from '../../../../shared/validators/max-file-size.validator'
import { FormControl } from '@angular/forms'
import {BehaviorSubject, Observable} from 'rxjs'

@Component({
  selector: 'app-piece-jointe-modal',
  imports: [CommonModule],
  templateUrl: './piece-jointe-modal.component.html',
  styleUrl: './piece-jointe-modal.component.scss',
})
export class PieceJointeModalComponent {
  @Input() pieceJointes: Observable<PieceJointe[]>;
  @Input() loading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  @Output() uploadDocument = new EventEmitter<File>()
  @Output() deleteDocument = new EventEmitter<number>()
  @Output() openDocument = new EventEmitter<PieceJointe>()

  errorMessage = signal<string>('')
  acceptedFormats = '.pdf,.jpg,.jpeg,.png,.xls,.xlsx,.doc,.docx'
  maxFileSizeBytes = 30 * 1024 * 1024 // 50 Mo

  private fileControl = new FormControl(null, [maxFileSize(this.maxFileSizeBytes)])

  constructor(public activeModal: NgbActiveModal) {}

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement
    if (!input.files || input.files.length === 0) {
      return
    }

    this.errorMessage.set('')

    const file = input.files[0]

    const validTypes = [
      'application/pdf',
      'image/jpeg',
      'image/png',
      'application/vnd.ms-excel',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'application/msword',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    ]

    if (!validTypes.includes(file.type)) {
      this.errorMessage.set('Format non accepté (PDF, JPG, PNG, Excel, Word uniquement)')
      input.value = ''
      return
    }

    this.fileControl.setValue(file)
    if (this.fileControl.hasError('maxFileSize')) {
      this.errorMessage.set('Fichier trop volumineux (max 50 Mo)')
      input.value = ''
      return
    }
    console.log(file)
    this.uploadDocument.emit(file)
    input.value = ''
  }

  onOpenDocument(pj: PieceJointe): void {
    this.openDocument.emit(pj)
  }

  onDeleteDocument(pj: PieceJointe): void {
    console.log(pj)
    this.deleteDocument.emit(pj.id)
  }

  closeModal(): void {
    this.activeModal.close()
  }
}

export interface PieceJointe {
  id: number
  titre: string
  url: string
}
